import { api } from "e.sic-platform.webclient/src/services/api/ApiService";
import { observer } from "mobx-react-lite";
import { useCallback, useState, useEffect } from "react";
import { reaction } from "mobx";
import {ShopHistoryStorage, mapStatus, FileStates, createAppLink} from "e.sic-platform.webclient/src/services/shop/ShopHistoryStorage";
import DataGrid from "e.sic-platform.webclient/src/components/datatable/DataGrid";
import {ActionsSection, ButtonsSection} from "e.sic-platform.webclient/src/components/data-components/sections/DataSections"
import DeleteButton from "e.sic-platform.webclient/src/components/buttons/delete-button/DeleteButton";
import { Box, Grid } from "@mui/material";
import { translationService } from "e.sic-platform.webclient/src/services/translation/TranslationService";
import { getActivityLabel } from "e.sic-platform.webclient/src/services/shop/ActivityPricesStorage";

export default observer(function ShopHistoryTable(props: {shopHistoryStorage: ShopHistoryStorage, rowClickPath?: string, showDeleteButton?: boolean, noSelection?: boolean}) {
  const {shopHistoryStorage, showDeleteButton = true, noSelection = false} = {...props};

  useEffect(() => {
    const dispose = reaction(
      () => translationService.language,
      () => {
        if (shopHistoryStorage.history) {
          shopHistoryStorage.history.forEach((item) => {
            const activityIsExpired =
              new Date(item.expiration) < new Date() ||
              item.status === FileStates.Deleted;

            shopHistoryStorage.updateRowDisplayValues(item.fileId, {
              service: {
                value: item.services,
                toDisplay: translationService.translate(
                  getActivityLabel(item.services)
                ),
              },
              status: {
                value: item.status,
                toDisplay: translationService.translate(mapStatus(item.status)),
              },
              outputLink: {
                value: item.guid,
                toDisplay: activityIsExpired
                  ? translationService.translate("shop.shop-history.expired")
                  : translationService.translate("shop.shop-histroy.link"), path: createAppLink(item)
              },
            });
          });
        }
      }
    );
    return () => dispose();
  }, [shopHistoryStorage]);

  const deleteAppResults = useCallback(() => {
    shopHistoryStorage.deleteFiles(shopHistoryStorage.selectedItems);
  }, []);

  const title = translationService.translate("shop.confirm-delete-title", {
    count: shopHistoryStorage.selectedItems.length,
  });

  return (
    <>
    {showDeleteButton && (
      <ActionsSection isSticky={false}>
        <ButtonsSection>
          <DeleteButton
            disabled={shopHistoryStorage.cannotDelete}
            confirmationModalTitleKey={title}
            confirmationModalSubtitleKey={"shop.confirm-delete-subtitle"}
            confirmationAction={deleteAppResults}
          />
        </ButtonsSection>
      </ActionsSection>
    )}
      <Grid container className="centered">
        <Box width="80vw">
          <DataGrid reloadOnRowClick rowClickPath={props.rowClickPath} itemTypeKey={"general.app-usage"} dataGridStorage={shopHistoryStorage} noSelection={noSelection} />
        </Box>
      </Grid>
    </>
  );
});
